import { NavLink } from 'react-router-dom'

import { joinClassNames } from '../../utils/styles'
import styles from './page-header.module.scss'

interface IMenuItem {
    title: string
    path: string
}

interface IPageHeaderProps {
    title: string
    menu?: IMenuItem[]
    children?: React.ReactNode
    className?: string
}

function PageHeader(props: IPageHeaderProps) {
    const { title, menu, children, className } = props

    return (
        <header className={joinClassNames(className, styles.pageHeader)}>
            <h1 className={styles.pageHeader__title}>{title}</h1>
            {menu ? (
                <nav className={styles.pageHeader__menu}>
                    {menu.map((menuItem) => (
                        <NavLink
                            key={menuItem.title}
                            className={({ isActive }) =>
                                joinClassNames(
                                    isActive &&
                                        styles.pageHeader__redirectBtnActive
                                )
                            }
                            to={menuItem.path}
                        >
                            {menuItem.title}
                        </NavLink>
                    ))}
                </nav>
            ) : null}
            <div className={styles.pageHeader__buttons}>{children}</div>
        </header>
    )
}

export default PageHeader
